module.exports = require('component-closest');


// WEBPACK FOOTER //
// ./~/min-dom/lib/closest.js